import { Link } from 'react-router-dom';

const Button = ({ children, to, variant = 'primary', onClick, className = '', type = 'button' }) => {
  const baseClass = 'px-6 py-3 font-semibold text-sm rounded-sm transition-all duration-300';
  const variantClass = variant === 'primary'
    ? 'bg-summit-navy text-white hover:bg-summit-navy-dark'
    : 'bg-white text-summit-navy border-2 border-summit-navy hover:bg-summit-navy hover:text-white';

  if (to) {
    return (
      <Link to={to} className={`${baseClass} ${variantClass} ${className} inline-block`}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={`${baseClass} ${variantClass} ${className}`}>
      {children}
    </button>
  );
};

export default Button;